import React from 'react'
import clsx from "clsx"
import DetailsDateSection from './DetailsDateSection'
import DetailsAccommodationSection from './DetailsAccommodationSection'

export default class ReservationSegmentCardPresenterDetails extends React.Component {

  constructor(props) {
    super(props)
  }
  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'details',
      'tab-pane': true
    });

    return (

      <div className={tabClasses} id="details">
        <div className="RoomDetails">
          <DetailsDateSection {...this.props} />
          <br></br>
          <DetailsAccommodationSection {...this.props}/>
        </div>
      </div>

    );
  };

};